import { Button } from "antd";
import { Link } from "react-router-dom";

import Header from "../../components/common/Layouts/Header";
import Footer from "../../components/common/Layouts/Footer";
import HelmetWrapper from "../../components/common/Layouts/HelmetWrapper";
import heroImage from "../../assets/images/hero.png";
import "../../assets/styles/components_styles/comingSoonPage.css";

export default function ComingSoon() {
  return (
    <>
      <HelmetWrapper
        title="Coming Soon - Pingvite"
        description="Pingvite is coming soon with exciting digital event experiences."
        keywords="Pingvite coming soon, events, webinars, conferences, workshops"
      />

      <Header />

      <main className="comingSoonPageRoot">
        <section className="comingSoonHero">
          <div className="container">
            <div className="comingSoonHeroGrid">
              <div className="comingSoonContent">
                <h1 className="comingSoonTitle">COMING SOON</h1>
                <p className="comingSoonText">
                  Pingvite is a great platform to explore digital events from across the globe!
                  Whether you are thinking of hosting a webinar, virtual conference, product launch,
                  or even an interactive workshop, Pingvite is designed to be your one-stop
                  destination.
                </p>
                <Link to="/">
                  <Button type="primary" size="large" className="btnGradient">
                    Home
                  </Button>
                </Link>
              </div>

              <div className="comingSoonVisualWrap">
                <img src={heroImage} alt="Pingvite coming soon banner" className="comingSoonVisual" />
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}

